import React from 'react';
import { Clock } from 'lucide-react';

const ACTIVE_STATUSES = ['New', 'Contacted', 'Quoted'];

/**
 * Follow-up reminder controls for a lead.
 * onSetFollowUp(leadId, daysFromNow) - pass null to clear the reminder.
 * Renders nothing for Lost or Converted leads.
 */
const FollowUpChips = ({ lead, onSetFollowUp, getFollowUpInfo }) => {
  if (!lead || !ACTIVE_STATUSES.includes(lead.status)) return null;

  const info = getFollowUpInfo(lead);
  const options = [
    { label: 'Tomorrow', days: 1 },
    { label: 'In 3 days', days: 3 },
    { label: 'Next week', days: 7 },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-gray-500 flex items-center gap-1">
          <Clock size={12} /> Follow-up reminder
        </p>
        {info && (
          <span className={`text-xs font-medium ${info.isDue ? 'text-amber-700' : 'text-gray-600'}`}>
            {info.label}
          </span>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.label}
            type="button"
            onClick={() => onSetFollowUp(lead.id, opt.days)}
            className="px-3 py-1.5 text-sm rounded-full border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {opt.label}
          </button>
        ))}
        {info && (
          <button
            type="button"
            onClick={() => onSetFollowUp(lead.id, null)}
            className="px-3 py-1.5 text-sm text-gray-500 hover:text-gray-700 underline"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default FollowUpChips;